class OnboardingQuiz extends HTMLElement {
  constructor() {
    super();

    this.timeout = setTimeout(() => {
      this.#showUserPrompt();
    }, 10000);

    this.#addEventListeners();
    this.#fireEvent('step_viewed', "step_1_spirit");
  }

  #addEventListeners() {
    this.querySelectorAll('.onboarding-quiz__option').forEach((option) => {
      option.addEventListener('click', (event) => {
        const selectedOption = event.target.closest('.onboarding-quiz__option');
        this.#onOptionSelected(event);

        const productType = this.#getProductType(selectedOption);
        this.#fireEvent("spirit_selected", productType);

        this.#moveToNextStep(); 
      });
    });
  }

  #onOptionSelected(event) {
    const selectedOption = event.target.closest('.onboarding-quiz__option');
    this.selectedStep = selectedOption.dataset.step;
  }

  #moveToNextStep() {
    const steps = this.querySelectorAll('.onboarding-quiz__step');

    steps.forEach((step) => {
      step.classList.add('hidden');
    });

    this.#showNextStep();

    window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 2 } }));
  }

  moveToStart() {
    const steps = this.querySelectorAll('.onboarding-quiz__step');

    steps.forEach((step) => {
      step.classList.add('hidden');
    });

    this.selectedStep = null;

    this.querySelector(`.onboarding-quiz__step[data-step="start"]`).classList.remove('hidden');

    window.dispatchEvent(new CustomEvent('change-checkout-step', { detail: { step: 1 } }));
  }

  #showUserPrompt() {
    if (this.selectedStep) {
      return;
    }

    this.querySelectorAll('.onboarding-quiz__option').forEach((spirit) => {
      spirit.classList.add('pulse');
    });

    this.timeout = setTimeout(() => {
      this.querySelectorAll('.onboarding-quiz__option').forEach((spirit) => {
        spirit.classList.remove('pulse');
      });
    }, 6000);
  }

  #showNextStep() {
    const comparisonTable = this.querySelector(`comparison-table[data-step="option_${this.selectedStep}"]`);
    comparisonTable.classList.remove('hidden');
    this.#fireEvent('step_viewed', "step_2_box");
  }

  #getProductType(option) {
    const handle = option.dataset.handles.toLowerCase();
    
    switch(handle) {
      case "gotm":
        return "gin";
      case "rotm":
        return "rum";
      default:
        return handle;
    }
  }

  #fireEvent(eventAction, eventValue) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'site_interaction',
      context: 'quiz_selection',
      action: eventAction,
      value: eventValue
    });
  }
}

if (!customElements.get('onboarding-quiz')) {
  window.customElements.define('onboarding-quiz', OnboardingQuiz);
}
